import React from "react";
import "../../../assets/css/user/topRatedDeals/TopRatedDeals.css";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import trend from '../../../assets/images/trend.jpg';
import trendi from '../../../assets/images/trendi.jpg';
import kids from '../../../assets/images/kids.jpg';


const BadgeIcon = ({ type }) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="badge-icon"
    >
      <path
        d={
          type === "trending"
            ? "M3 14l4-4 3 3 5-6 2 1"
            : type === "instant"
            ? "M11 2L4 11h7l-2 7 7-9h-7l2-7z"
            : "M10 17c-3.3 0-6-2.5-6-5.5 0-2 1-3.5 2.5-4.5 0 1.5.8 2.5 1.5 3 .2-1.5 1-3.5 3-5 0 2 1.2 3.5 2 4.5.5-1 .5-2 .5-2.5C14.5 8.5 16 10 16 11.5c0 3-2.7 5.5-6 5.5z"
        }
        stroke="#ffffff"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ClockIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" className="clock-icon">
    <circle cx="8" cy="8" r="6.5" stroke="#4f46e5" strokeWidth="1.4" />
    <path d="M8 5v3.5l2 1.5" stroke="#4f46e5" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

const StarIcon = () => (
  <svg viewBox="0 0 14 14" fill="#f59e0b" className="star-icon">
    <path d="M7 1l1.5 4H13l-3.5 2.5 1.5 4L7 9 3 11.5l1.5-4L1 5h4.5L7 1z" />
  </svg>
);

const deals = [
  {
    id: 1,
    badge: "Trending",
    badgeType: "trending",
    discount: "37% OFF",
    category: "Food & Drink",
    seller: "Royal Kitchen",
    title: "Family Dinner Buffet (4 Persons)",
    titleHighlight: true,
    rating: 4.9,
    reviews: 256,
    price: "PKR 4,999",
    originalPrice: "PKR 8,000",
    timer: null,
    image: trend,
  },
  {
    id: 2,
    badge: "Instant",
    badgeType: "instant",
    discount: "62% OFF",
    category: "Health & Wellness",
    seller: "SmileCare Clinic",
    title: "Dental Checkup + Cleaning",
    titleHighlight: false,
    rating: 4.7,
    reviews: 167,
    price: "PKR 1,500",
    originalPrice: "PKR 4,000",
    timer: "1h 15m left",
    image: trendi,
  },
  {
    id: 3,
    badge: "Hot",
    badgeType: "hot",
    discount: "40% OFF",
    category: "Family & Kids",
    seller: "FunLand Karachi",
    title: "Kids Birthday Party Package",
    titleHighlight: false,
    rating: 4.6,
    reviews: 78,
    price: "PKR 15,000",
    originalPrice: "PKR 25,000",
    timer: null,
    image: kids,
  },
  {
    id: 4,
    badge: "Trending",
    badgeType: "trending",
    discount: "25% OFF",
    category: "Beauty & Spa",
    seller: "Zen Spa Lahore",
    title: "Full Body Massage & Facial",
    titleHighlight: false,
    rating: 4.8,
    reviews: 312,
    price: "PKR 3,500",
    originalPrice: "PKR 4,700",
    timer: "2h 30m left",
    image: trendi,
  },
];

const DealCard = ({ deal }) => {
  return (
    <div className={`deal-card deal-card--${deal.badgeType}`}>
      {/* Image */}
      <div className="deal-card__image">
        <img
          src={deal.image}
          alt={deal.title}
          className="deal-card__img"
          loading="lazy"
          onError={(e) => {
            e.target.style.display = "none";
            e.target.parentElement.classList.add("deal-card__image--fallback");
          }}
        />
        {/* Dark gradient overlay — same as BlogCard */}
        <div className="deal-card__overlay" />

        {/* Badges on top of image */}
        <span className={`deal-badge deal-badge--${deal.badgeType}`}>
          <BadgeIcon type={deal.badgeType} /> {deal.badge}
        </span>
        <span className="deal-discount">{deal.discount}</span>
        {deal.timer && (
          <span className="deal-timer">
            <ClockIcon /> {deal.timer}
          </span>
        )}
      </div>

      {/* Card body */}
      <div className="deal-card__body">
        <p className="deal-meta">
          {deal.category} · <span>{deal.seller}</span>
        </p>
        <h3 className={`deal-title${deal.titleHighlight ? " deal-title--link" : ""}`}>
          {deal.title}
        </h3>
        <div className="deal-rating">
          <StarIcon />
          <span className="rating-value">{deal.rating}</span>
          <span className="rating-count">({deal.reviews})</span>
        </div>
        <div className="deal-pricing">
          <span className="deal-price">{deal.price}</span>
          <span className="deal-original">{deal.originalPrice}</span>
        </div>
      </div>
    </div>
  );
};

const TopRatedDeals = () => {
    const navigate = useNavigate();
  return (
    <section className="top-rated-section">
      <div className="section-header">
        <div>
          <h2 className="section-title">Top Rated Deals</h2>
          <p className="section-subtitle">Highest rated by our community</p>
        </div>
        <button
          className="blog-view-all"
          onClick={() => navigate("/deals")}
        >
          View All <ArrowRight />
        </button>
      </div>

      <div className="deals-grid">
        {deals.map((deal) => (
          <DealCard key={deal.id} deal={deal} />
        ))}
      </div>
    </section>
  );
};

export default TopRatedDeals;